export const PAGE_ITEMS_LIMIT = 24;
export const COMPACT_PAGE_ITEMS_LIMIT = 100;
